var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { load } from "worker-timers-broker";
import { createLoadOrReturnBroker } from "./factories/load-or-return-broker";
export class Timers {
    constructor(assetsLocation) {
        this.assetsLocation = assetsLocation;
        this.clearInterval = (timerId) => this.loadOrReturnBroker().clearInterval(timerId);
        this.clearTimeout = (timerId) => this.loadOrReturnBroker().clearTimeout(timerId);
        this.setInterval = (...args) => this.loadOrReturnBroker().setInterval(...args);
        this.setTimeout = (...args) => this.loadOrReturnBroker().setTimeout(...args);
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.loadOrReturnBroker) {
                this.loadOrReturnBroker = yield createLoadOrReturnBroker(load, this.assetsLocation);
            }
        });
    }
}
